const m = {
  small: { min: 320, max: 479 },
  medium: { min: 480, max: 649 },
  large: { min: 650, max: 767 },
  tablet: { min: 768, max: 1023 },
  desktop: { min: 1024, max: 1199 },
  highDef: { min: 1200, max: 1499 },
  maximum: { min: 1500 }
}, i = {
  small: {
    min: `${m.small.min}px`,
    max: `${m.small.max}px`
  },
  medium: {
    min: `${m.medium.min}px`,
    max: `${m.medium.max}px`
  },
  large: {
    min: `${m.large.min}px`,
    max: `${m.large.max}px`
  },
  tablet: {
    min: `${m.tablet.min}px`,
    max: `${m.tablet.max}px`
  },
  desktop: {
    min: `${m.desktop.min}px`,
    max: `${m.desktop.max}px`
  },
  highDef: {
    min: `${m.highDef.min}px`,
    max: `${m.highDef.max}px`
  },
  maximum: { min: `${m.maximum.min}px` }
}, a = {
  small: {
    min: `min-width: ${i.small.min}`,
    max: `max-width: ${i.small.max}`
  },
  medium: {
    min: `min-width: ${i.medium.min}`,
    max: `max-width: ${i.medium.max}`
  },
  large: {
    min: `min-width: ${i.large.min}`,
    max: `max-width: ${i.large.max}`
  },
  tablet: {
    min: `min-width: ${i.tablet.min}`,
    max: `max-width: ${i.tablet.max}`
  },
  desktop: {
    min: `min-width: ${i.desktop.min}`,
    max: `max-width: ${i.desktop.max}`
  },
  highDef: {
    min: `min-width: ${i.highDef.min}`,
    max: `max-width: ${i.highDef.max}`
  },
  maximum: { min: `min-width: ${i.maximum.min}` }
}, e = {
  "--isMediaSmall": !1,
  "--isMediaSmallMax": !1,
  "--isMediaMedium": !1,
  "--isMediaMediumMax": !1,
  "--isMediaLarge": !1,
  "--isMediaLargeMax": !1,
  "--isMediaTablet": !1,
  "--isMediaTabletMax": !1,
  "--isMediaDesktop": !1,
  "--isMediaDesktopMax": !1,
  "--isMediaHighDef": !1,
  [`@media (${a.small.min})`]: {
    "--isBreakpointSmall": !0
  },
  [`@media (${a.small.max})`]: {
    "--isBreakpointSmallMax": !0
  },
  [`@media (${a.medium.min})`]: {
    "--isBreakpointMedium": !0
  },
  [`@media (${a.medium.max})`]: {
    "--isBreakpointMediumMax": !0
  },
  [`@media (${a.large.min})`]: {
    "--isBreakpointLarge": !0
  },
  [`@media (${a.large.max})`]: {
    "--isBreakpointLargeMax": !0
  },
  [`@media (${a.tablet.min})`]: {
    "--isTablet": !0
  },
  [`@media (${a.tablet.max})`]: {
    "--isTabletMax": !0
  },
  [`@media (${a.desktop.min})`]: {
    "--isDesktop": !0
  },
  [`@media (${a.desktop.max})`]: {
    "--isDesktopMax": !0
  },
  [`@media (${a.highDef.min})`]: {
    "--isHighDef": !0
  }
};
export {
  m as breakpointValues,
  i as breakpoints,
  e as conditionals,
  a as queries
};
//# sourceMappingURL=media.js.map
